import { Row, Col } from 'react-bootstrap';
import { Checkbox } from 'appkit-react';

const Append = ({ updatedConfigData, onHandleChange, concateData }) => (
    <Row>
        <Col>
            <p className="true-comply-datarecon__reconcliationtype-concatenation__title">COLUMN LIST</p>
            <Row>
                { updatedConfigData && updatedConfigData.map(c => (
                    <Col key={c.id}>
                        <p>{c.fileDisplayName}</p>
                        <ul className="true-comply-datarecon__reconcliationtype-concatenation__list-checkbox">
                            {
                                c.selectedColumns.map(data => (
                                    <li key={data.column}>
                                        <Checkbox
                                            checked={data.isConcateCheck}
                                            onChange={onHandleChange}
                                            id={c.id}
                                            name={data.column}
                                            value={data.column}
                                        >
                                            {data.column}
                                        </Checkbox>
                                    </li>
                                ))
                            }
                        </ul>
                    </Col>
                ))}
            </Row>
        </Col>
        <Col>
            <p className="true-comply-datarecon__reconcliationtype-concatenation__title">APPEND</p>
            <Row>
                { concateData && concateData.map(c => (
                    <Col key={c.id}>
                        <p>{c.fileDisplayName}</p>
                        <ul className="true-comply-datarecon__reconcliationtype-concatenation__list">
                            {
                                c.selectedColumns.map(data => <li key={data.column}>{data.column}</li>)
                            }
                        </ul>
                    </Col>
                ))}
            </Row>
        </Col>
    </Row>
);

export default Append;
